export const DEFAULT_CONCESSION_DISCOUNT_TEXT = 'Concession discount included';
export const DEFAULT_SHIPPING_CALCULATION_NOTE = 'Any shipping discounts will be calculated at checkout';
export const ORDER_PRODUCT_TAX_DISCLAIMER = 'Prices include GST';
